import { useQuery } from '@tanstack/react-query'
import { getSellingTypeForSeats } from 'api/ticket'

type SellingTypeRecord = Record<string, { isLocalSelling: boolean }>

export const useSellingTypeForSeats = (eventId: string) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['selling-type-map', eventId],
        queryFn: () => getSellingTypeForSeats(eventId),
        enabled: !!eventId,
        select: (sellingTypeMap): SellingTypeRecord => {
            return Array.isArray(sellingTypeMap)
                ? sellingTypeMap.reduce((acc, curr) => {
                      acc[curr.seatId] = { isLocalSelling: curr.isLocalSelling }
                      return acc
                  }, {} as SellingTypeRecord)
                : {}
        },
    })

    return { data, isLoading, error }
}
